export { default as Interpolator } from './interpolator';